import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Sharebar from "./components/sharebar";
import Gallery from "./components/gallery";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";
import BacktoTop from "./components/back-to-top";
import KeyNumbers from "./components/key-numbers";
import JobDetails from "./components/job-details";
import FileInput from "./components/file";

import DeviceManager from "./utils/device-manager";

// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home slider component
		const $homesSliders = $(".homepage-slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// News slider component
		const $newsSliders = $(".news-list--slider");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}

		// Partners slider component
		const $partnersSliders = $(".partners-slider");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews-slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// BU Product slider component
		const $buProductSlider = $(".bu-products-slider");
		if ($buProductSlider.length) {
			$buProductSlider.each(function (index, el) {
				const buProductSlider = new BUProductSlider($(el));
			});
		}

		// Portal page slider component
		const $portalPageSliders = $(".portal-page__header-slider");
		if ($portalPageSliders.length) {
			$portalPageSliders.each(function (index, el) {
				const portalPageSlider = new PortalPageSlider($(el));
			});
		}

		// Newsletter form component
		const $newsletterFormElements = $(".footer-block.footer-block--newsletter-style");
		if ($newsletterFormElements.length) {
			$newsletterFormElements.each(function (index, el) {
				const newsletterForm = new NewsletterForm(el);
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	}

	bootstrapApp();
	instanciateComponents();

	// HEADER - Calcul hauteur padding-top
	const setBodyPaddingTop = () => {
		var header = $('.site-header');
		var headerHeight = header.outerHeight();
		var body = $('body');

		if( $(window).width() > 1023) {
			body.css('padding-top', headerHeight + 'px');
		} else {
			body.css('padding-top', '0px');
			header.css('transform', 'none');
		}
	}

	$(document).ready(function () {
		setBodyPaddingTop();
	});

	$(window).resize(function(){
		setBodyPaddingTop();
	});

});

// })(jQuery);
